import React from 'react';
import { useNavigate } from 'react-router-dom';

const DEPARTMENTS = [
    { name: 'OPD', label: 'Out Patient', icon: '🏥', color: '#1e3a5f', bg: '#eff6ff', path: '/opd/register' },
    { name: 'IPD', label: 'In Patient', icon: '🛏️', color: '#065f46', bg: '#f0fdf4', path: '/ipd/register' },
    { name: 'ER', label: 'Emergency', icon: '🚨', color: '#991b1b', bg: '#fef2f2', path: '/ae/new' },
    { name: 'Radiology', label: 'Radiology / PACS', icon: '🩻', color: '#4c1d95', bg: '#f5f3ff', path: '/pacs/order' },
    { name: 'Lab', label: 'Laboratory', icon: '🔬', color: '#7c2d12', bg: '#fff7ed', path: '/lab/order' },
];

export default function Departments() {
    const navigate = useNavigate();

    return (
        <div>
            <h2 style={{ fontSize: 22, fontWeight: 700, color: '#1e293b', marginBottom: 8 }}>Departments</h2>
            <p style={{ color: '#64748b', fontSize: 14, marginBottom: 30 }}>Select a department to register a patient</p>

            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: 20 }}>
                {DEPARTMENTS.map(dept => (
                    <div key={dept.name} onClick={() => navigate(dept.path)}
                        style={{
                            background: dept.bg, border: `2px solid ${dept.color}22`,
                            borderRadius: 14, padding: 30, cursor: 'pointer',
                            textAlign: 'center', transition: 'transform 0.15s, box-shadow 0.15s',
                        }}
                        onMouseOver={e => { e.currentTarget.style.transform = 'translateY(-4px)'; e.currentTarget.style.boxShadow = '0 8px 24px rgba(0,0,0,0.1)'; }}
                        onMouseOut={e => { e.currentTarget.style.transform = 'translateY(0)'; e.currentTarget.style.boxShadow = 'none'; }}
                    >
                        <div style={{ fontSize: 52, marginBottom: 14 }}>{dept.icon}</div>
                        <div style={{ fontSize: 20, fontWeight: 800, color: dept.color }}>{dept.name}</div>
                        <div style={{ fontSize: 13, color: '#64748b', marginTop: 4 }}>{dept.label}</div>
                        <div style={{ marginTop: 16, padding: '8px 20px', background: dept.color, color: 'white', borderRadius: 8, fontSize: 13, fontWeight: 600 }}>
                            Register Patient
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
}
